module.exports = __webpack_public_path__ + "047ee29f4be8ed7d2077d767fde5c281.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/santa-hat.png
// module id = 2327
// module chunks = 0